var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7404_65994)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 2.75C7.5 2.33579 7.16421 2 6.75 2C6.33579 2 6 2.33579 6 2.75V6.10352C4.84575 6.42998 4 7.49122 4 8.75C4 10.2688 5.23122 11.5 6.75 11.5C8.26878 11.5 9.5 10.2688 9.5 8.75C9.5 7.49122 8.65425 6.42998 7.5 6.10352V2.75ZM6.75 7.5C6.05964 7.5 5.5 8.05964 5.5 8.75C5.5 9.44036 6.05964 10 6.75 10C7.44036 10 8 9.44036 8 8.75C8 8.05964 7.44036 7.5 6.75 7.5ZM7.5 13.75C7.5 13.3358 7.16421 13 6.75 13C6.33579 13 6 13.3358 6 13.75V20.75C6 21.1642 6.33579 21.5 6.75 21.5C7.16421 21.5 7.5 21.1642 7.5 20.75V13.75ZM16 14.75C16 15.4404 15.4404 16 14.75 16C14.0596 16 13.5 15.4404 13.5 14.75C13.5 14.0596 14.0596 13.5 14.75 13.5C15.4404 13.5 16 14.0596 16 14.75ZM15.5 17.3965V20.75C15.5 21.1642 15.1642 21.5 14.75 21.5C14.3358 21.5 14 21.1642 14 20.75V17.3965C12.8457 17.07 12 16.0088 12 14.75C12 13.2312 13.2312 12 14.75 12C16.2688 12 17.5 13.2312 17.5 14.75C17.5 16.0088 16.6543 17.07 15.5 17.3965ZM15.5 2.75C15.5 2.33579 15.1642 2 14.75 2C14.3358 2 14 2.33579 14 2.75V9.75C14 10.1642 14.3358 10.5 14.75 10.5C15.1642 10.5 15.5 10.1642 15.5 9.75V2.75Z",
    fill: "url(#paint0_linear_7404_65994)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7404_65994",
    x1: 10.75,
    y1: -8.98456,
    x2: -8.98863,
    y2: 3.14481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7404_65994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.269f87d3b576092c66eee7cfa80d6926.svg";
export { ForwardRef as ReactComponent };